import { styled } from '@mui/system';

export const Main = styled('main')<{noPadding?: boolean}>`
  padding: ${({ noPadding }) => noPadding ? '0' : '16px'};
`;